import React from 'react';

interface StarsProps {
  rating: number;
  count?: number;
  size?: 'sm' | 'md';
}

export const Stars: React.FC<StarsProps> = ({ rating, count, size = 'md' }) => {
  const full = Math.round(rating);
  return (
    <span className={`stars stars-${size}`} aria-label={`Rating: ${rating.toFixed(1)} out of 5`}>
      {'★'.repeat(full)}{'☆'.repeat(5 - full)}
      {count !== undefined && <span className="stars-count">({count})</span>}
    </span>
  );
};
